<template>
  <v-card elevation="0" class="all-trade-tab rounded-0 deposit-tab">
    <v-tabs v-model="model" :background-color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
      <v-tab v-if="hasLiveTradesAccess" :href="`#tab-1`" class="pl-0 ml-0">
        <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
        Tradable Bonus History
      </v-tab>
     
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <v-card flat>
            <TradableBonusTab></TradableBonusTab>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

import TradableBonusTab from "./TradableBonusTab.vue";
export default {

  data() {
    return {
      tab: null,
      model: "tab-2",
    };
  },
  components: {
    TradableBonusTab,
  },
  computed: {
    ...mapState("admins", ["loggedAdmin"]),
    
    
    hasLiveTradesAccess() {
      const accessType = this.loggedAdmin?.access_type;

      if (accessType === 1) return true;
      if (accessType === 2) return false;

      if (accessType === 3) {
        const menuAccess = this.loggedAdmin?.permissions['Trades Section']?.access;
        if (menuAccess === 'Full Control') return true;
        if (menuAccess === 'Read Only') return false;
        if (menuAccess === 'Custom Access') {
          const subMenuAccess = this.loggedAdmin?.permissions['Trades Section']?.subMenus?.['Live Trades'];
          return subMenuAccess === 'Full Control';
        }
      }

      return false;
    },

  },

};
</script>
